import React, { useEffect, useState } from "react";
import { getImageUrl } from "../../../../commons/assets_path";
import { PageLoader } from "../../Loaders/PageLoader";
import axios from "axios";
import styles from "./CommonSettings.module.scss";
import cummonStyles from "../SettingModal.module.scss";
import Modal from "react-modal";
import FormInputText from "../Forms/FormInputText";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { useTranslation } from "react-i18next";

import type { NoticeType } from "../../../../types/settingsTypes";

type PopupType = "support" | "maximumTask" | "destroyWorkSpace";

type Props = {
  client: {
    code: string;
    id: number;
    plan_code: string;
  };
  updateTaskLimitPolicy: boolean;
  isAdmin: boolean;
  setNotice: React.Dispatch<React.SetStateAction<NoticeType>>;
  new_member_session_path: string;
  changeModalCss: (width: string, height: string) => void;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setHeaderShow: (show: boolean) => void;
};

type DestroyFormType = {
  password_confirm: string;
  client_company_name_confirm: string;
  client_name_confirm: string;
  reason: string;
};

const CommonSettings = ({
  client,
  updateTaskLimitPolicy,
  isAdmin,
  setNotice,
  new_member_session_path,
  changeModalCss,
  setIsMenuOpen,
  setHeaderShow,
}: Props) => {
  const { i18n, t } = useTranslation();

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [currentPopup, setCurrentPopup] = useState<PopupType | null>(null);
  const [isSupported, setIsSupported] = useState<boolean>();
  const [isTaskLimitActive, setIsTaskLimitActive] = useState<boolean>(false);
  const [taskLimit, setTaskLimit] = useState<string>();
  const [isTaskLimitActivePerDay, setIsTaskLimitActivePerDay] = useState<boolean>(false);
  const [taskLimitPerDay, setTaskLimitPerDay] = useState<string>();
  const [isSupportPeriod, setIsSupportPeriod] = useState<any>();
  const [TimeZones, setTimeZones] = useState<any>();
  const [currentTimeZone, setCurrentTimeZone] = useState<string>();
  const [allowLocales, setAllowLocales] = useState<any>();
  const [currentLocale, setCurrentLocale] = useState<string>();
  const [isTimetech, setIsTimetech] = useState<boolean>();
  const [loading, setLoading] = useState<boolean>(true);
  const [taskLimitForm, setTaskLimitForm] = useState<string>();
  const [taskLimitPerDayForm, setTaskLimitPerDayForm] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<{ [key: string]: string }>({});
  const [destroyForm, setDestroyForm] = useState<DestroyFormType>({
    password_confirm: "",
    client_company_name_confirm: "",
    client_name_confirm: "",
    reason: "",
  });
  const [isDeletable, setIsDeletable] = useState<boolean>(true);
  const [mode, setMode] = useState<"default" | "support" | "taskLimit" | "destroyWorkSpace">("default");
  const [isGoogleSsoAuthenticated, setIsGoogleSsoAuthenticated] = useState<boolean>(false);

  const openPopup = (type: PopupType) => {
    setCurrentPopup(type);
    setModalIsOpen(true);
  };

  const closePopup = () => {
    setCurrentPopup(null);
    setModalIsOpen(false);
  };

  const popupStyles = () => {
    const baseStyles = {
      overlay: {
        zIndex: 1501,
        background: "rgba(34,34,34, 0.3)",
      },
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: 40,
      },
    };

    if (currentPopup === "destroyWorkSpace") {
      baseStyles.content.maxWidth = 765;
    }

    return baseStyles;
  };

  const getCummonSettingData = async () => {
    const endpoint = `/${client.code}/settings/common_setting/retrieve`;

    const result = await axios.get(endpoint);

    if (result?.data) {
      const {
        support_settings,
        is_task_limit_active,
        task_limit,
        is_task_limit_active_per_day,
        task_limit_per_day,
        time_zones,
        current_time_zone,
        allowed_locales,
        current_locale,
        is_timetech,
        member,
      } = result.data.common_setting;
      setIsSupported(support_settings.is_supported);
      setIsTaskLimitActive(is_task_limit_active);
      setTaskLimit(task_limit);
      setTaskLimitForm(task_limit);
      setTaskLimitPerDayForm(task_limit_per_day);
      setIsTaskLimitActivePerDay(is_task_limit_active_per_day);
      setTaskLimitPerDay(task_limit_per_day);
      setIsSupportPeriod({
        isActive: support_settings.is_support_period_active,
        support_period_start_date: support_settings.support_period_start_date,
        support_period_end_date: support_settings.support_period_end_date,
      });
      setTimeZones(time_zones);
      setCurrentTimeZone(current_time_zone);
      setAllowLocales(allowed_locales);
      setCurrentLocale(current_locale);
      setIsTimetech(is_timetech);
      setIsGoogleSsoAuthenticated(member.is_google_sso_authenticated);
    }
    setLoading(false);
  };

  const updateIsSupported = async (value: boolean) => {
    const endpoint = `/clients/${client.id}/update_is_supported`;

    const result = await axios
      .patch(endpoint, {
        client: {
          is_supported: value,
        },
      })
      .catch((error) => {
        setNotice({
          type: "alert",
          message: error.response.data.message,
        });
        closePopup();
      });

    if (result?.data) {
      setIsSupported(!isSupported);
      setNotice({
        type: "success",
        message: result.data.message,
      });
      closePopup();
    }
  };

  const updateTaskLimit = async () => {
    const endpoint = `/clients/${client.id}/update_task_limit`;
    const clientData: any = {
      is_task_limit_active: isTaskLimitActive,
      is_task_limit_active_per_day: isTaskLimitActivePerDay,
    };
    if (isTaskLimitActive) {
      clientData.task_limit = taskLimitForm;
    }
    if (isTaskLimitActivePerDay) {
      clientData.task_limit_per_day = taskLimitPerDayForm;
    }

    const result = await axios
      .patch(endpoint, {
        client: clientData,
      })
      .catch((error) => {
        setErrorMessage(error.response.data.errors);
        return;
      });

    if (result?.data) {
      setTaskLimit(taskLimitForm);
      setTaskLimitPerDay(taskLimitPerDayForm);
      setNotice({
        type: "success",
        message: result.data.message,
      });
      closePopup();
      setErrorMessage({});
    }
  };

  const deleteWorkSpace = async () => {
    const endpoint = `/${client.code}/settings/clients/${client.id}/push_destroy_request`;

    await axios
      .post(endpoint, {
        client: destroyForm,
      })
      .then((response) => {
        window.location.href = response.data.redirect_url;
      })
      .catch((error) => {
        setNotice({
          type: "alert",
          message: error.response.data.message,
        });
        closePopup();
        setIsDeletable(true);
      });
  };

  const updateTimeZone = async (value: string) => {
    const endpoint = `/clients/${client.id}/update_time_zone`;
    const result = await axios
      .patch(endpoint, {
        client: {
          time_zone: value,
        },
      })
      .catch((error) => {
        setNotice({
          type: "alert",
          message: error.response.data.message,
        });
      });

    if (result?.data) {
      setCurrentTimeZone(value);
      setNotice({
        type: "success",
        message: result.data.message,
      });
    }
  };

  const updateLocale = async (value: string) => {
    const endpoint = `/clients/${client.id}/update_locale`;
    await axios
      .patch(endpoint, {
        client: {
          locale: value,
        },
      })
      .then((res) => {
        setCurrentLocale(value);
        setNotice({
          type: "success",
          message: res.data.message,
        });

        setTimeout(() => {
          const params = new URLSearchParams(window.location.search);
          params.set("category", "common");
          window.location.href = `${window.location.pathname}?${params.toString()}`;
        }, 2000);
      })
      .catch((error) => {
        setNotice({
          type: "alert",
          message: error.response.data.message,
        });
      });
  };

  const handleDeleteWorkSpace = () => {
    if (isDeletable) {
      setIsDeletable(false);
      deleteWorkSpace();
    }
  };

  useEffect(() => {
    getCummonSettingData();
  }, []);

  const renderContent = () => {
    switch (mode) {
      case "support":
        return (
          <div className={cummonStyles.popup}>
            <h1 className={cummonStyles.popupTitle} data-testid="common-support-setting-title">
              {t("CommonSettings.サポート設定をオンにしますか？")}
            </h1>
            <p className={cummonStyles.text}>
              {t(
                "CommonSettings.サポート設定をオンにすると、Yoomのカスタマーサポートスタッフがこのワークスペースにアクセス可能になります。",
              )}
            </p>
            <div className={cummonStyles.buttonContent}>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setMode("default");
                  setIsMenuOpen(true);
                  changeModalCss("100%", "auto");
                  setHeaderShow(true);
                }}
              >
                {t("CommonSettings.キャンセル")}
              </button>
              <button className="btn btn-info" onClick={() => updateIsSupported(true)}>
                {t("CommonSettings.オンにする")}
              </button>
            </div>
          </div>
        );

      case "taskLimit":
        return (
          <div className={cummonStyles.popup}>
            <div className={styles.modalContent}>
              <div className={styles.modalSubItem}>
                <h1 className={cummonStyles.popupTitle} data-testid="common-task-limit-setting-title">
                  {t("CommonSettings.タスク実行上限数を変更")}
                </h1>
                <p className={styles.modalText}>
                  {t("CommonSettings.1ヶ月及び1日のタスクの実行上限数を設定することができます。")}
                </p>
                <p className={styles.modalText}>
                  {t(
                    "CommonSettings.フローボット起動後にタスク実行数を超えた場合、フローボットは停止しないため、実際のタスク数は上限を超えることがありますのでご了承くださいませ。",
                  )}
                </p>
              </div>
              <div className={styles.modalSubItem}>
                <div className="custom-control custom-switch">
                  <input
                    id="test-support-change-maximum-task"
                    className="custom-control-input"
                    type="checkbox"
                    defaultChecked={isTaskLimitActive}
                    onChange={() => setIsTaskLimitActive((prev) => !prev)}
                  />
                  <label className="custom-control-label font-weight-bolder" htmlFor="test-support-change-maximum-task">
                    {t("CommonSettings.1ヶ月のタスク実行上限数を設定する")}
                  </label>
                </div>
                {isTaskLimitActive && (
                  <div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <input
                        type="number"
                        className={`${styles.modalInput} ${errorMessage.task_limit ? `${styles.errorInput}` : ""}`}
                        value={taskLimitForm}
                        placeholder="10000"
                        onChange={(e) => setTaskLimitForm(e.target.value)}
                      />
                      {errorMessage.task_limit && (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img src={getImageUrl("images/icons/error.svg")} />
                          <div style={{ color: "#FF4958", fontSize: "12px" }}>{errorMessage.task_limit}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.modalSubItem}>
                <div className="custom-control custom-switch">
                  <input
                    id="task-limit-active-per-day"
                    className="custom-control-input"
                    type="checkbox"
                    defaultChecked={isTaskLimitActivePerDay}
                    onChange={() => setIsTaskLimitActivePerDay((prev) => !prev)}
                  />
                  <label className="custom-control-label font-weight-bolder" htmlFor="task-limit-active-per-day">
                    {t("CommonSettings.1日のタスク実行上限数を設定する")}
                  </label>
                </div>
                {isTaskLimitActivePerDay && (
                  <div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <input
                        type="number"
                        className={`${styles.modalInput} ${
                          errorMessage.task_limit_per_day ? `${styles.errorInput}` : ""
                        }`}
                        value={taskLimitPerDayForm}
                        placeholder="500"
                        onChange={(e) => setTaskLimitPerDayForm(e.target.value)}
                      />
                      {errorMessage.task_limit_per_day && (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img src={getImageUrl("images/icons/error.svg")} />
                          <div style={{ color: "#FF4958", fontSize: "12px" }}>{errorMessage.task_limit_per_day}</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={cummonStyles.buttonContent}>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setMode("default");
                  setIsMenuOpen(true);
                  changeModalCss("100%", "auto");
                  setHeaderShow(true);
                }}
              >
                {t("CommonSettings.キャンセル")}
              </button>
              <button className="btn btn-info" onClick={updateTaskLimit}>
                {t("CommonSettings.変更する")}
              </button>
            </div>
          </div>
        );

      case "destroyWorkSpace":
        return (
          <div className={cummonStyles.popup}>
            <h1 className={cummonStyles.popupTitle} data-testid="test-destroy-workspace-modal">
              {t("CommonSettings.ワークスペースの削除")}
            </h1>
            <p className={`${cummonStyles.text} ${cummonStyles.smallText}`}>
              {t("CommonSettings.ワークスペースの削除をご希望の方は、以下の注意事項をご確認ください。")}
              <br />
              {t(
                "CommonSettings.・この申請はユーザーの削除ではなく、ワークスペースの削除です。削除対象のワークスペースにすべてのユーザーがログインできなくなります。",
              )}
              <br />
              {t("CommonSettings.・削除が完了すると、データが消去されます。復元することはできません。")}
              <br />
              {t(
                "CommonSettings.・ワークスペースが削除されると、このワークスペースにのみ所属しているユーザーアカウントも同時に削除されます。",
              )}
              <br />
              <br />
              {t(
                "CommonSettings.上記注意事項に同意の上、必要事項をご入力いただき、「削除する」をクリックしてください。",
              )}
            </p>
            <FormInputText
              label={isGoogleSsoAuthenticated ? t("CommonSettings.mail_address") : t("CommonSettings.パスワード")}
              value={destroyForm.password_confirm}
              type={isGoogleSsoAuthenticated ? "text" : "password"}
              onChange={(e) => setDestroyForm((prev) => ({ ...prev, password_confirm: e.target.value }))}
            />
            <FormInputText
              label={t("CommonSettings.会社・名前")}
              value={destroyForm.client_company_name_confirm}
              onChange={(e) => setDestroyForm((prev) => ({ ...prev, client_company_name_confirm: e.target.value }))}
            />
            <FormInputText
              label={t("CommonSettings.ワークスペース名")}
              value={destroyForm.client_name_confirm}
              onChange={(e) => setDestroyForm((prev) => ({ ...prev, client_name_confirm: e.target.value }))}
            />
            <FormInputText
              label={t("CommonSettings.削除理由")}
              value={destroyForm.reason}
              type="long-text"
              onChange={(e) => setDestroyForm((prev) => ({ ...prev, reason: e.target.value }))}
            />
            <div style={{ display: "flex", justifyContent: "end" }}>
              <div className={cummonStyles.buttonContent} style={{ width: 332 }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setMode("default");
                    setIsMenuOpen(true);
                    changeModalCss("100%", "auto");
                    setHeaderShow(true);
                  }}
                >
                  {t("CommonSettings.キャンセル")}
                </button>
                <button
                  className={`btn btn-secondary bg-danger border-danger ${cummonStyles.deleteBtn}`}
                  onClick={handleDeleteWorkSpace}
                  disabled={client.plan_code !== "free" || !isDeletable}
                >
                  {t("CommonSettings.削除する")}
                </button>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className={styles.formContent}>
            <h1 className={styles.title} data-testid="common-settings-title">
              {t("CommonSettings.共通設定")}
            </h1>
            {!loading ? (
              <>
                <div className={styles.formItem} data-testid="test-cummon-setting-content">
                  <div>
                    <div className={styles.formItemLabel}>
                      {t("CommonSettings.サポート設定")}
                      {isSupportPeriod.isActive && (
                        <>
                          {t("CommonSettings.support_period", {
                            start: isSupportPeriod.support_period_start_date,
                            end: isSupportPeriod.support_period_end_date,
                          })}
                        </>
                      )}
                    </div>
                    <p className={styles.formItemDescription}>
                      {t("CommonSettings.Yoom株式会社のアクセスを許可する（1週間経過すると自動的にオフになります）")}
                    </p>
                  </div>
                  <div className="custom-control custom-switch">
                    <input
                      id="test-support-switch"
                      className="custom-control-input"
                      type="checkbox"
                      onChange={() => {
                        if (isSupported) {
                          updateIsSupported(false);
                        } else {
                          setMode("support");
                          setIsMenuOpen(false);
                          changeModalCss("765px", "auto");
                          setHeaderShow(false);
                        }
                      }}
                      checked={isSupported}
                    />
                    <label className="custom-control-label font-weight-normal" htmlFor="test-support-switch"></label>
                  </div>
                </div>
                {updateTaskLimitPolicy && (
                  <div className={styles.formItem}>
                    <div>
                      <div className={styles.formItemLabel}>{t("CommonSettings.タスク実行数上限")}</div>
                      <p style={{ marginBottom: 1, paddingTop: 5 }}>
                        {t("CommonSettings.現在の上限数")}：
                        {isTaskLimitActive && t("CommonSettings.monthly_limit_count", { taskLimit })}
                        {isTaskLimitActive && isTaskLimitActivePerDay && "、"}
                        {isTaskLimitActivePerDay && t("CommonSettings.daily_limit_count", { taskLimitPerDay })}
                        {!isTaskLimitActive && !isTaskLimitActivePerDay && t("CommonSettings.なし")}
                      </p>
                      <p className={styles.formItemDescription}>
                        {t("CommonSettings.毎月または毎日のタスク実行数の上限数を設定することが可能です。")}
                        <br />
                        {t(
                          "CommonSettings.タスク実行数を設定したい場合は、有効にするをオンにして、値を設定してください。",
                        )}
                      </p>
                    </div>
                    <button
                      className={`btn btn-info btn-sm-size ${styles.btnInfo}`}
                      onClick={() => {
                        setMode("taskLimit");
                        setIsMenuOpen(false);
                        changeModalCss("765px", "auto");
                        setHeaderShow(false);
                      }}
                      data-testid="task-limit-setting-modal-open"
                    >
                      {t("CommonSettings.変更する")}
                    </button>
                  </div>
                )}
                {isAdmin && (
                  <div className={styles.formItem}>
                    <div>
                      <div className={styles.formItemLabel}>{t("CommonSettings.ワークスペースの削除")}</div>
                      <p className={styles.formItemDescription} data-testid="test-cummon-setting-warning-message">
                        {t("CommonSettings.有料プランを契約中のワークスペースは削除することができません。")}
                        <br />
                        {t("CommonSettings.ワークスペースの削除はフリープランに変更後実施してください。")}
                      </p>
                    </div>
                    <button
                      className={`btn btn-secondary btn-sm-size ${styles.btnSecondary}`}
                      onClick={() => {
                        setMode("destroyWorkSpace");
                        setIsMenuOpen(false);
                        changeModalCss("765px", "auto");
                        setHeaderShow(false);
                      }}
                      disabled={client.plan_code !== "free"}
                      style={{
                        color: client.plan_code !== "free" ? "#fff" : "#ff4958",
                        cursor: client.plan_code !== "free" ? "not-allowed" : "pointer",
                      }}
                      data-testid="test-cummon-setting-destroy-btn"
                    >
                      {t("CommonSettings.削除する")}
                    </button>
                  </div>
                )}
                {isAdmin && isTimetech && (
                  <div className={styles.formItem}>
                    <div>
                      <div className={styles.formItemLabel}>{t("CommonSettings.タイムゾーン")}</div>
                      <p className={styles.formItemDescription}>{t("CommonSettings.※現在は社内WSのみ設定可能です")}</p>
                    </div>
                    <select
                      className="form-control"
                      value={currentTimeZone}
                      onChange={(e) => updateTimeZone(e.target.value)}
                      style={{
                        width: "290px",
                        margin: 0,
                        backgroundImage: "none",
                      }}
                    >
                      {TimeZones &&
                        Object.entries(TimeZones).map(([key, value], i) => (
                          <option key={i} value={key}>
                            {value as string}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
                {isAdmin && isTimetech && (
                  <div className={styles.formItem}>
                    <div>
                      <div className={styles.formItemLabel}>{t("CommonSettings.言語設定")}</div>
                      <p className={styles.formItemDescription}>{t("CommonSettings.※現在は社内WSのみ設定可能です")}</p>
                    </div>
                    <select
                      className="form-control"
                      value={currentLocale}
                      onChange={(e) => updateLocale(e.target.value)}
                      style={{
                        width: "290px",
                        margin: 0,
                        backgroundImage: "none",
                      }}
                    >
                      {allowLocales &&
                        Object.entries(allowLocales).map(([key, value], i) => (
                          <option key={i} value={key}>
                            {value as string}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </>
            ) : (
              <PageLoader loadingHeight={"50vh"} />
            )}
          </div>
        );
    }
  };

  return <>{renderContent()}</>;
};

export default CommonSettings;
